var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wheel-container"},[_c('div',{staticClass:"wheel"},[_c('div',[_c('SlotMachineWheelItem',{attrs:{"item":_vm.prevItem}})],1),_vm._v(" "),_c('div',{staticClass:"selected"},[_c('SlotMachineWheelItem',{attrs:{"item":_vm.item}})],1),_vm._v(" "),_c('div',[_c('SlotMachineWheelItem',{attrs:{"item":_vm.nextItem}})],1)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8baf56d8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SlotMachine/SlotMachineWheel.vue
// module id = null
// module chunks = 